import { render, staticRenderFns } from "./CompleteRegister.vue?vue&type=template&id=3da5f9ff&"
import script from "./CompleteRegister.vue?vue&type=script&lang=js&"
export * from "./CompleteRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports